import { RouteRecordRaw } from 'vue-router';
import { requireAuth, setDayjsTimezone } from '@/common/router/navigationGuard';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import { requireInstances, requireDomainTargetOrTutorial } from '@/common/router/authGuard';
import { VIEW_MODE } from '@/common/define/common.define';

const PREFIX_DATABASE = 'database_';

const databaseMenu: RouteRecordRaw[] = [
  {
    path: '/database/',
    name: `${PREFIX_DATABASE}Database`,
    component: BaseViewport,
    beforeEnter: [
      requireAuth,
      () => requireDomainTargetOrTutorial('database'),
      requireInstances,
      setDayjsTimezone,
    ],
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE,
      invisibleViewMode: [VIEW_MODE.INTERMAX],
      viewport: VIEWPORT_TYPE.REALTIME,
    },
    children: [
      {
        path: 'instance',
        name: `${PREFIX_DATABASE}Instance`,
        component: () => import('../views/instanceView/InstanceView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_DATABASE_INSTANCE,
        },
      },
    ],
  },
];

const getDatabaseNaviMenu = () => {
  const filteredDatabaseMenu = extractAccessibleRoutes(databaseMenu);

  return [...filteredDatabaseMenu];
};

export { databaseMenu, getDatabaseNaviMenu };
